import { Component } from '@angular/core';
import { ExpandableComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-expandable',
  imports: [ExpandableComponent],
  template: `
    <div>
      <h1 class="heading-title">Expandable</h1>
      <div class="flex flex-col gap-5">
        <flk-expandable>
          <h3 title>Basic Expandable (Collapsed by default)</h3>
          <p content>
            This is the content of the expandable section. It is hidden by
            default.
          </p>
        </flk-expandable>

        <flk-expandable [initiallyExpanded]="true">
          <h3 title>Initially Expanded Example</h3>
          <div content class="flex flex-col gap-3">
            <p>This expandable starts in an expanded state.</p>
            <p>You can put any content here, including multiple elements.</p>
          </div>
        </flk-expandable>

        <flk-expandable>
          <h3 title>Expandable with Rich Content</h3>
          <div content class="flex flex-col gap-3">
            <h3 class="font-bold">Nested Heading</h3>
            <p>You can include any type of content inside the expandable:</p>
            <ul class="list-inside list-disc">
              <li>Lists</li>
              <li>Images</li>
              <li>Forms</li>
              <li>Other components</li>
            </ul>
          </div>
        </flk-expandable>

        <flk-expandable [reverse]="true">
          <h3 title>Expandable with Rich Content</h3>
          <div content class="flex flex-col gap-3">
            <h3 class="font-bold">Nested Heading</h3>
            <p>You can include any type of content inside the expandable:</p>
            <ul class="list-inside list-disc">
              <li>Lists</li>
              <li>Images</li>
              <li>Forms</li>
              <li>Other components</li>
            </ul>
          </div>
        </flk-expandable>

        <flk-expandable [reverse]="true" [borderless]="true">
          <h3 title>Expandable with Rich Content</h3>
          <div content class="flex flex-col gap-3">
            <h3 class="font-bold">Nested Heading</h3>
            <p>You can include any type of content inside the expandable:</p>
            <ul class="list-inside list-disc">
              <li>Lists</li>
              <li>Images</li>
              <li>Forms</li>
              <li>Other components</li>
            </ul>
          </div>
        </flk-expandable>
      </div>
    </div>
  `,
})
export class UIExpandableComponent {}
